import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useCheckUserRole } from './hooks/useCheckUserRole';

function Home() {
    const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('isLoggedIn') === 'true');
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

        // Kullanıcı rolünü kontrol edin
        useCheckUserRole(['admin', 'editor', 'user']);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setIsLoading(false);
        }, 1000);

        const storedIsLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
        setIsLoggedIn(storedIsLoggedIn);

        if (!storedIsLoggedIn) {
            navigate('/login');
        }

        return () => clearTimeout(timeoutId);
    }, [navigate]);

    useEffect(() => {
        if (!isLoggedIn) {
            navigate('/login');
        }
    }, [isLoggedIn, navigate]);

    return (
        <>
            {isLoading && (
                <div className="loader">
                    <div className="loader-inner">
                        <div className="circle"></div>
                    </div>
                </div>
            )}
            {!isLoading && (
                <>
                    <div className="hero-area hero-bg">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-9 offset-lg-2 text-center">
                                    <div className="hero-text">
                                        <div className="hero-text-tablecell">
                                            <p className="subtitle">Oranlar Tahminler</p>
                                            <h1>En İyi Tahminler</h1>
                                            <div className="hero-btns">
                                                <Link to="/oranlar" className="boxed-btn">Oranlar</Link>
                                                <Link to="/editor" className="bordered-btn">Editör</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="list-section pt-80 pb-80">
                        <div className="container">
                            <div className="row justify-content-center">
                                {/* 
<div className="col-lg-4 col-md-6 mb-4 mb-lg-0">                                     
    <div className="list-box d-flex align-items-center">                                         
        <div className="list-icon">                                             
            <i className="fas fa-shipping-fast"></i>                                         
        </div>                                         
        <div className="content">                                             
            <h3>Ucuz Fiyat</h3>                                             
            <p>Editörlerimizin Tahminleriyle Kazanabilirsiniz!</p>                                         
        </div>                                     
    </div>                                 
</div> 
*/}
                                <div className="col-lg-4 col-md-6 mb-4 mb-lg-0">
                                    <div className="list-box d-flex align-items-center">
                                        <div className="list-icon">
                                            <i className="fas fa-phone-volume"></i>
                                        </div>
                                        <div className="content">
                                            <h3>7/24 Tahmin</h3>
                                            <p>Canlı Tablolarımızla 7/24 Maç Takibi</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <div className="list-box d-flex justify-content-start align-items-center">
                                        <div className="list-icon">
                                            <i className="fas fa-sync"></i>
                                        </div>
                                        <div className="content">
                                            <h3>Eski Maçlar</h3>
                                            <p>Eski Oranlarla Karşılaştırabilirsiniz!</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </>
            )}
        </>
    );
}

export default Home;
